<h1 id="impot-personnel">Impôt personnel</h1>

<div class="card">
  <div class="card-body">
    <div class="d-flex gap-5">
      <app-salary-dividend-personal-tax-spouse-form
              class="flex-fill"
              [form]="form"
              [incomeTaxPersonalSpouseForm]="mainPersonForm"
              [isSpouse]="false"
      ></app-salary-dividend-personal-tax-spouse-form>

      @if (this.incomeTaxPersonalForm.value.isMarried === true) {
        <app-salary-dividend-personal-tax-spouse-form
                class="flex-fill"
                [form]="form" [incomeTaxPersonalSpouseForm]="spouseForm"
                [isSpouse]="true"></app-salary-dividend-personal-tax-spouse-form>
      }
    </div>

  </div>
</div>


<div class="mt-5">
  <app-salary-dividend-personal-tax-children-form [children]="childrenForm"
                                                  [form]="form"></app-salary-dividend-personal-tax-children-form>
</div>



